import Vue from 'vue'
import Router from 'vue-router'
import appMain from './views/appMain.vue'
import Home from './views/page/home/home.vue'
import {Toast} from 'mand-mobile'
Vue.use(Router)

export default new Router({
    // mode: 'history',
    // base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            redirect:"/appMain"
        },
        {
            path: '/appMain',
            component: appMain,
            children:[
                {
                    path: '/',
                    component:Home
                },
                {
                    path: 'home',
                    name: 'home',
                    component:Home
                },
                {
                    path:'brand',//品牌
                    name: 'brand',
                    component:() => import(/* webpackChunkName: "about" */ './views/page/brand/brand.vue')
                },
                {
                    path:'member', //我的
                    name: 'member',
                    component:() => import(/* webpackChunkName: "about" */ './views/page/member/member.vue'),
                    beforeEnter: (to, from, next) => {
                        let user = localStorage.getItem("login")
                        if(user !== '0'){
                            next()
                        }else {
                            Toast.failed('用户未注册')
                            next({path:'/register'})
                        }

                    }
                },
                {
                    path: 'memberRuleList', //会员规则列表
                    name: 'memberRuleList',
                    component:() => import(/* webpackChunkName: "about" */ './views/page/home/memberRuleList.vue')
                },

                {
                    path: 'memberDatum', //会员资料
                    name: 'memberDatum',
                    component:() => import(/* webpackChunkName: "about" */ './views/page/home/memberDatum.vue'),
                    beforeEnter: (to, from, next) => {
                        let user = localStorage.getItem("login")
                        if(user !== '0'){
                            next()
                        }else {
                            Toast.failed('用户未注册')
                            next('/register')
                        }

                    }
                },
                {
                    path: 'integralTicket', //积分换券
                    name: 'integralTicket',
                    component:() => import(/* webpackChunkName: "about" */ './views/page/home/integralTicket.vue'),
                    beforeEnter: (to, from, next) => {
                        let user = localStorage.getItem("login")
                        if(user !== '0'){
                            next()
                        }else {
                            Toast.failed('用户未注册')
                            next({path:'/register'})
                        }

                    }
                },
                {
                    path: 'integralTicketConvert', //积分兑换券
                    name: 'integralTicketConvert',
                    component:() => import(/* webpackChunkName: "about" */ './views/page/home/integralTicketConvert.vue'),
                    beforeEnter: (to, from, next) => {
                        let user = localStorage.getItem("login")
                        if(user !== '0'){
                            next()
                        }else {
                            Toast.failed('用户未注册')
                            next({path:'/register'})
                        }

                    }
                },
                {
                    path: 'integralGift', //积分换礼
                    name: 'integralGift',
                    component:() => import(/* webpackChunkName: "about" */ './views/page/home/integralGift.vue'),
                    beforeEnter: (to, from, next) => {
                        let user = localStorage.getItem("login")
                        if(user !== '0'){
                            next()
                        }else {
                            Toast.failed('用户未注册')
                            next({path:'/register'})
                        }

                    }
                },
                {
                    path: 'exchangeDetails', //兑换详情
                    name: 'exchangeDetails',
                    component:() => import(/* webpackChunkName: "about" */ './views/page/home/exchangeDetails.vue'),
                    beforeEnter: (to, from, next) => {
                        let user = localStorage.getItem("login")
                        if(user !== '0'){
                            next()
                        }else {
                            Toast.failed('用户未注册')
                            next({path:'/register'})
                        }

                    }
                },
                {
                    path: 'getGift', //领取礼品记录 口令兑换
                    name: 'getGift',
                    component:() => import(/* webpackChunkName: "about" */ './views/page/home/getGift.vue'),
                    beforeEnter: (to, from, next) => {
                        let user = localStorage.getItem("login")
                        if(user !== '0'){
                            next()
                        }else {
                            Toast.failed('用户未注册')
                            next({path:'/register'})
                        }

                    }
                },
                {
                    path: 'getGiftDetails', //领取礼品记录详情
                    name: 'getGiftDetails',
                    component:() => import(/* webpackChunkName: "about" */ './views/page/home/getGiftDetails.vue'),
                    beforeEnter: (to, from, next) => {
                        let user = localStorage.getItem("login")
                        if(user !== '0'){
                            next()
                        }else {
                            Toast.failed('用户未注册')
                            next({path:'/register'})
                        }

                    }
                },
                {
                    path: 'integralTicketDetails', //积分换券记录详情
                    name: 'integralTicketDetails',
                    component:() => import(/* webpackChunkName: "about" */ './views/page/home/integralTicketDetails.vue'),
                    beforeEnter: (to, from, next) => {
                        let user = localStorage.getItem("login")
                        if(user !== '0'){
                            next()
                        }else {
                            Toast.failed('用户未注册')
                            next({path:'/register'})
                        }

                    }
                },
                {
                    path: 'serviceContentList', //服务中心
                    name: 'serviceContentList',
                    component:() => import(/* webpackChunkName: "about" */ './views/page/home/serviceContentList.vue')
                },
                {
                    path: 'takingPicturesIntegral', //拍照积分
                    name: 'takingPicturesIntegral',
                    component:() => import(/* webpackChunkName: "about" */ './views/page/home/takingPicturesIntegral.vue')
                },
                {
                    path: 'integralRecord', //拍照积分记录
                    name: 'integralRecord',
                    component:() => import(/* webpackChunkName: "about" */ './views/page/home/integralRecord.vue')
                },
                {
                    path: 'signIn', //我要签到
                    name: 'signIn',
                    component:() => import(/* webpackChunkName: "about" */ './views/page/home/signIn2.vue'),
                    beforeEnter: (to, from, next) => {
                        let user = localStorage.getItem("login")
                        if(user !== '0'){
                            next()
                        }else {
                            Toast.failed('用户未注册')
                            next({path:'/register'})
                        }

                    }
                },
                {
                    path: 'classify', //服务中心
                    name: 'classify',
                    component:() => import(/* webpackChunkName: "about" */ './views/page/classify/classify.vue')
                },

            ]
        },
        {
            path: '/register', //注册
            name: 'register',
            component: () => import(/* webpackChunkName: "about" */ './views/register.vue')
        },
        {
            path: '/integralGiftConvert', //积分换礼兑换
            name: 'integralGiftConvert',
            component:() => import(/* webpackChunkName: "about" */ './views/page/home/integralGiftConvert.vue'),
            beforeEnter: (to, from, next) => {
                let user = localStorage.getItem("userData")
                if(user){
                    next()
                }else {
                    Toast.failed('用户未注册')
                    next({path:'/register'})
                }

            }
        },

        {
            path: '/brandDetails', //品牌详情
            name: 'brandDetails',
            component:() => import(/* webpackChunkName: "about" */ './views/page/brand/brandDetails.vue')
        },
        {
            path: '/stopCarSucceed', //核销成功
            name: 'stopCarSucceed',
            component:() => import(/* webpackChunkName: "about" */ './views/page/home/stopCarSucceed.vue')
        },
        {
            path: '/stopCarError', //核销失败
            name: 'stopCarError',
            component:() => import(/* webpackChunkName: "about" */ './views/page/home/stopCarError.vue')
        },
        {
            path: '/stopCar', //智能停车
            name: 'stopCar',
            component:() => import(/* webpackChunkName: "about" */ './views/page/home/stopCar.vue')
        },
        {
            path: '/carPay', //停车缴款
            name: 'carPay',
            component:() => import(/* webpackChunkName: "about" */ './views/page/home/carPay.vue')
        },
        {
            path: '/memberRule', //会员规则详情
            name: 'memberRule',
            component:() => import(/* webpackChunkName: "about" */ './views/page/home/memberRule.vue')
        },
        {
            path: '/memberRule2', //会员规则详情
            name: 'memberRule2',
            component:() => import(/* webpackChunkName: "about" */ './views/page/home/memberRule2.vue')
        },
        {
            path: '/serviceContent', //服务中心详情
            name: 'serviceContent',
            component:() => import(/* webpackChunkName: "about" */ './views/page/home/serviceContent.vue')
        },
        {
            path: '/shopDetails', //广告详情
            name: 'shopDetails',
            component:() => import(/* webpackChunkName: "about" */ './views/page/home/shopDetails.vue')
        },
        {
            path: '/shopGiftDetails', //广告详情2
            name: 'shopGiftDetails',
            component:() => import(/* webpackChunkName: "about" */ './views/page/home/shopGiftDetails.vue')
        },
        {
            path: '/myCoupon', //我要卡券
            name: '/myCoupon',
            component:() => import(/* webpackChunkName: "about" */ './views/page/member/myCoupon.vue'),
            beforeEnter: (to, from, next) => {
                let user = localStorage.getItem("userData")
                if(user){
                    next()
                }else {
                    Toast.failed('用户未注册')
                    next({path:'/register'})
                }

            }
        },
        {
            path: '/ticketDetails', //广告详情2
            name: 'ticketDetails',
            component:() => import(/* webpackChunkName: "about" */ './views/page/home/ticketDetails.vue')
        },
        {
            path: '/gameList', //活动列表
            name: 'gameList',
            component:() => import(/* webpackChunkName: "about" */ './views/page/member/gameList.vue')
        },
        {
            path: '/gameWheel', //大转盘
            name: 'gameWheel',
            component:() => import(/* webpackChunkName: "about" */ './views/page/member/gameWheel.vue'),
            beforeEnter: (to, from, next) => {
                let user = localStorage.getItem("userData")
                if(user){
                    next()
                }else {
                    Toast.failed('用户未注册')
                    next({path:'/register'})
                }

            }
        },
        {
            path: '/gameGold', //点屏成金
            name: 'gameGold',
            component:() => import(/* webpackChunkName: "about" */ './views/page/member/gameGold.vue'),
            beforeEnter: (to, from, next) => {
                let user = localStorage.getItem("userData")
                if(user){
                    next()
                }else {
                    Toast.failed('用户未注册')
                    next({path:'/register'})
                }

            }
        },
        {
            path: '/modificationVip', //会员资料修改
            name: 'modificationVip',
            component:() => import(/* webpackChunkName: "about" */ './views/page/member/modificationVip.vue'),
        }
    ]
})
